import { useTLang } from 'intl/intl';
import { SFStockoutItemChip } from 'features/order/substitution-flow';
import type { SubstitutionFlowReplacementProduct } from 'shared/domain/order/orderDetail.model';
import makeClasses from './SFReplacementOptions.style';
import { formatCurrency } from 'utils/CurrencyUtils';

export function SFReplacementOptions(props: Props) {
  const { replacementItems } = props;

  const title = useTLang({ id: 'substitutionFlow.040' });
  const _classes = makeClasses();

  return (
    <section className={_classes.wrapper}>
      <h3 className={_classes.title}>{title}</h3>
      {replacementItems.map(replacementItem => (
        <article
          key={`replacement-options-${replacementItem.productId}`}
          aria-label='replacement-options'
        >
          <header className={_classes.header}>
            <h4>
              <span>{`${replacementItem?.units}x `}</span>
              {replacementItem?.name}
              <SFStockoutItemChip mode='options' />
            </h4>
            {replacementItem.price > 0 && (
              <span>{formatCurrency(replacementItem.price)}</span>
            )}
          </header>
          <p className={_classes.description}>{replacementItem?.description}</p>
        </article>
      ))}
    </section>
  );
}

interface Props {
  replacementItems: SubstitutionFlowReplacementProduct[];
}
